import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	max-width: 1030px;
	margin: 0 auto;
	color: ${CSSVars.black};
	padding: 50px 20px;

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 100px 40px;
	}

	h2 {
		font-size: ${CSSVars.fontSize2XL};
		text-align: left;
		margin-bottom: 30px;
		max-width: 680px;
		margin-left: 0;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			margin-bottom: 50px;
			font-size: ${CSSVars.fontSize3XL};
		}
	}

	.card {
		max-width: 1420px;
		display: flex;
		justify-content: space-between;
		margin: 0 auto;
		background-color: ${CSSVars.gray50};
		color: ${CSSVars.gray900};
		border-radius: 10px;

		flex-direction: column;
		gap: 30px;

		@media screen and (min-width: ${CSSVars.breakpointLG}) {
			flex-direction: row;
		}

		@media screen and (min-width: ${CSSVars.breakpointXL}) {
			gap: 100px;
		}
	}

	.list {
		display: flex;
		flex-direction: column;
		gap: 30px;

		.card {
			background-color: white;
			max-width: 1030px;
			width: 100%;

			.slider-text {
				.title-wrapper {
					display: flex;
					gap: 20px;
					flex-direction: column;
					margin-bottom: 20px;

					.step-dot {
						width: fit-content;
						border-radius: 10px;
						background-color: ${CSSVars.gray50};
						display: flex;
						align-items: center;
						justify-content: center;
						padding: 10px 15px;
						font-size: ${CSSVars.fontSizeXL};
					}

					h5 {
						font-size: ${CSSVars.fontSizeXL};
					}
				}

				.install-p {
					img {
						max-width: 100%;
					}
				}
			}
		}
	}

	.text-and-dots {
		display: flex;
		gap: 30px;
		align-items: center;
		flex-direction: column;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			flex-direction: row;
			gap: 70px;
		}

		.step-dots {
			display: flex;
			gap: 20px;
			flex-direction: row;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				flex-direction: column;
			}

			.step-dot {
				border-radius: 10px;
				background-color: ${CSSVars.gray300};
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 7px 10px;
				font-size: ${CSSVars.fontSizeMD};
				cursor: pointer;
				transition: 0.2s;
				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: ${CSSVars.fontSizeLG};
					padding: 10px 13px;
				}

				&:hover {
					background-color: ${CSSVars.blue100};
				}

				&.active {
					color: ${CSSVars.white};
					background-color: ${CSSVars.blue500};
				}
			}
		}

		.slider-text {
			h5 {
				font-size: ${CSSVars.fontSizeLG};
				margin-bottom: 20px;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: ${CSSVars.fontSizeXL};
				}
			}

			p {
				font-size: ${CSSVars.fontSizeLG};
				font-weight: 300;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: ${CSSVars.fontSizeXL};
				}
			}
		}
	}

	.img-container {
		background-color: ${CSSVars.white};
		border: 2px solid ${CSSVars.gray50};
		border-radius: 10px;
		padding: 5px;
		max-width: 100%;
		position: relative;

		.zoom {
			position: absolute;
			top: 10px;
			right: 10px;
			background-color: ${CSSVars.white};
			color: ${CSSVars.gray700};
			width: 30px;
			height: 30px;
			padding: 2px;
			border-radius: 50em;
			z-index: 10;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
		}

		@media screen and (min-width: ${CSSVars.breakpointLG}) {
			min-width: 440px;
			max-width: 440px;
			min-height: 300px;
			max-height: 300px;
		}

		img {
			object-fit: contain;
			position: relative !important;
		}
	}

	.link {
		border: none;
		margin: 20px auto 0;
		&:hover {
			background: none;
			color: ${CSSVars.blue700};
		}
	}

	.credit-text {
		margin-top: 100px;
	}
`;
